export default {
      id: "tabStripShowMoreActionMenu-usage",
      viewBox: "0 0 12 7",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#tabStripShowMoreActionMenu",
      toString: function () {
        return this.url;
      }
    }